import { bool, oneOf, shape } from "prop-types";
import { blackColors, brandColors, commonColors, whiteColors } from "../utils/color";

export const fontSizePropTypes = oneOf(["xs", "s", "m", "l", "xl", "xxl", "xxxl"]);
export const colorPropTypes = oneOf([
	...brandColors,
	...blackColors,
	...whiteColors,
	...commonColors,
]);
export const textAlignPropTypes = oneOf(["left", "center", "right"]);
const textDecorationPropTypes = oneOf(["underline", "none"]);
const textTransformPropTypes = oneOf(["uppercase", "capitalize"]);
const fontWeightPropTypes = oneOf([
	100,
	200,
	300,
	400,
	500,
	600,
	700,
	800,
	900,
	"thin",
	"ultra-light",
	"light",
	"normal",
	"medium",
	"semi",
	"bold",
	"extra",
	"heavy",
]);

export const sxProps = {
	textAlign: null,
	textTransform: null,
	textEllipsis: null,
	fontSize: null,
	fontColor: null,
	fontWeight: null,
	fontStyle: null,
	hover: {
		fontColor: null,
	},
	sm: {
		textAlign: null,
	},
	md: {
		textAlign: null,
	},
	lg: {
		textAlign: null,
	},
};

export const sxPropTypes = shape({
	textAlign: textAlignPropTypes,
	textTransform: textTransformPropTypes,
	textEllipsis: bool,
	fontSize: fontSizePropTypes,
	fontColor: colorPropTypes,
	textDecoration: textDecorationPropTypes,
	fontWeight: fontWeightPropTypes,
	fontStyle: oneOf(["italic"]),
	hover: shape({
		fontColor: colorPropTypes,
		bgColor: colorPropTypes,
		textDecoration: textDecorationPropTypes,
	}),
	sm: shape({
		textAlign: textAlignPropTypes,
	}),
	md: shape({
		textAlign: textAlignPropTypes,
	}),
	lg: shape({
		textAlign: textAlignPropTypes,
	}),
});

export const sxClassName = ({ ...props }, isHeading = false) => {
	const {
		textAlign,
		textTransform,
		textEllipsis,
		fontSize,
		fontColor,
		textDecoration,
		fontWeight,
		fontStyle,
		hover,
		sm,
		md,
		lg,
	} = props;
	return [
		fontSize && (isHeading ? `heading-${fontSize}` : `text-${fontSize}`),
		fontColor && `text-color-${fontColor}`,
		hover && hover.fontColor && `text-color-${hover.fontColor}--hover`,
		fontWeight && `text-weight--${fontWeight}`,
		fontStyle && `text-${fontStyle}`,
		textAlign && `text-${textAlign}`,
		textDecoration && `text-decoration--${textDecoration}`,
		hover && hover.textDecoration && `text-decoration--${hover.textDecoration}--hover`,
		hover && hover.bgColor && `bg-color-${hover.bgColor}--hover`,
		textTransform && `text-${textTransform}`,
		textEllipsis && "text-ellipsis",
		sm && sm.textAlign && `small-text-${sm.textAlign}`,
		md && md.textAlign && `medium-text-${md.textAlign}`,
		lg && lg.textAlign && `large-text-${lg.textAlign}`,
	];
};
